import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../common/DashboardApp";
import {
  getApplicationList,
  applicationStatusChange,
} from "../../../service/employerapi";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const ApplicationList = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [applications, setApplication] = useState([]);
  const { jobId } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [selectedApplicationId, setSelectedApplicationId] = useState(null);
  const [hourlyRate, setHourlyRate] = useState("");

  useEffect(() => {
    if (location.state?.toastMessage) {
      toast.success(location.state.toastMessage);
    }

    const fetchApplications = async () => {
      try {
        setLoading(true);
        const response = await getApplicationList(jobId);
        console.log(response);
        setApplication(response.data || []);
      } catch (err) {
        console.error("Error fetching Applications:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  const handleApplicationStatus = async (
    applicationId,
    employerApprovalStatus
  ) => {
    try {
      const payload = {
        applicationId,
        employerApprovalStatus,
      };

      if (employerApprovalStatus === "Approved") {
        payload.hourlyRate = Number(hourlyRate);
      }

      const res = await applicationStatusChange(payload);

      if (res.data.status) {
        toast.success(`Application ${employerApprovalStatus} successfully!`);

        setApplication((prev) =>
          prev.map((app) =>
            app.applicationId === applicationId
              ? { ...app, employerApprovalStatus }
              : app
          )
        );

        setShowModal(false);
        setHourlyRate("");
        setSelectedApplicationId(null);
      } else {
        toast.error(res.data.message || "Failed to update status");
      }
    } catch (err) {
      console.error("Error updating status:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="panelCard">
          <div className="titlSectionu userpaneltitle text-left position-relative">
            <h2>Applications List</h2>
          </div>

          {loading ? (
            <div className="text-center w-100 my-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : applications.length === 0 ? (
            <div className="col-12">
              <div className="alert alert-info text-center">
                No Applications found.
              </div>
            </div>
          ) : (
            <table className="table mt-4 hj-table">
              <thead>
                <tr>
                  <th scope="col">Sl. No.</th>
                  <th scope="col">Candidate Name</th>
                  <th scope="col">Phone & Email</th>
                  <th scope="col">Location</th>
                  <th scope="col">Status</th>
                  <th scope="col">Hourly Rate</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((application, index) => (
                  <tr key={application.applicationId || index}>
                    <td>{index + 1}</td>

                    <td>
                      <a href="/candidate-profile">
                        <div className="transactiondetials d-flex align-items-center gap-3">
                          {application.image ? (
                            <img
                              src={application.image}
                              alt="icon"
                              className="astrologImg"
                            />
                          ) : (
                            <img
                              src="/assets/img/company-profiles/image-1.png"
                              alt="icon"
                              className="astrologImg"
                            />
                          )}

                          <div className="transactiondinfo">
                            <h5>{application.jobSeekerName}</h5>
                            <p>{application.jobProfile}</p>
                          </div>
                        </div>
                      </a>
                    </td>

                    <td>
                      <div className="transactiondinfo">
                        <h5>+91 {application.phoneNumber}</h5>
                        <p>{application.email}</p>
                      </div>
                    </td>

                    <td>
                      {application.city}, {application.state}
                    </td>

                    <td>
                      <span
                        style={{
                          backgroundColor:
                            application.employerApprovalStatus === "Approved"
                              ? "#00e721"
                              : application.employerApprovalStatus ===
                                "Rejected"
                              ? "#e71b00"
                              : "#e7b100",
                          padding: "2px 12px",
                          borderRadius: "15px",
                          color: "#fff",
                        }}
                      >
                        {application.employerApprovalStatus || "Pending"}
                      </span>
                    </td>

                    <td>₹{application.hourlyRate || 0}</td>

                    <td>
                      {application.employerApprovalStatus === "Pending" && (
                        <div className="d-flex gap-2">
                          <button
                            className="mainbtn"
                            title="Reject"
                            onClick={() =>
                              handleApplicationStatus(
                                application.applicationId,
                                "Rejected"
                              )
                            }
                          >
                            Reject
                          </button>
                          <button
                            className="mainbtn"
                            style={{
                              backgroundColor: "#270b79",
                              border: "1px solid #270b79",
                            }}
                            title="Approve"
                            onClick={() => {
                              setSelectedApplicationId(
                                application.applicationId
                              );
                              setShowModal(true);
                            }}
                          >
                            Approve
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {showModal && (
            <div
              className="modal fade show"
              style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
              tabIndex="-1"
              onClick={(e) => {
                if (e.target.classList.contains("modal")) setShowModal(false);
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleApplicationStatus(
                        selectedApplicationId,
                        "Approved"
                      );
                    }}
                  >
                    <div className="modal-body">
                      <div className="mb-3 mt-3 hj-form">
                        <label htmlFor="hourlyRate">
                          Hourly Rate <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="hourlyRate"
                          value={hourlyRate}
                          onChange={(e) => setHourlyRate(e.target.value)}
                          placeholder="Enter Hourly Rate"
                          required
                        />
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="mainbtn"
                        style={{
                          backgroundColor: "#270b79",
                          border: "1px solid #270b79",
                        }}
                      >
                        Approve
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ApplicationList;
